import * as React from 'react';

export function SvgCoda(props: any) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4121 2H4.85471C4.4345 2.0007 4.03164 2.16765 3.73411 2.46438C3.43658 2.76111 3.26855 3.16353 3.26672 3.58373V19.4168C3.26869 19.8369 3.43678 20.2392 3.7343 20.5358C4.03181 20.8324 4.43459 20.9993 4.85471 21H19.4121C19.8322 20.9993 20.235 20.8324 20.5325 20.5358C20.83 20.2392 20.9981 19.8369 21.0001 19.4168V18.6773C20.9735 17.7277 20.9469 15.7487 20.9469 14.8513C20.9469 14.3501 20.5766 13.9277 20.0999 13.9277C19.5706 13.9277 19.2264 14.2443 18.9615 14.5081C18.1677 15.221 16.9772 15.3529 15.9451 15.1678C15.4684 15.0625 15.0184 14.9305 14.6476 14.6933C13.5096 14.0336 12.7686 12.793 12.7686 11.4737C12.7686 10.1543 13.5096 8.94033 14.6476 8.25407C15.045 8.0168 15.4945 7.88487 15.9446 7.77953C16.95 7.5944 18.1683 7.72633 18.962 8.4392C19.253 8.70307 19.5972 9.01907 20.1005 9.01907C20.5766 9.01907 20.9469 8.5972 20.9469 8.09607C20.9469 7.2252 20.9735 5.2196 21.0001 4.26947V3.5832C20.9979 3.16318 20.8298 2.76104 20.5323 2.46453C20.2348 2.16803 19.8321 2.00123 19.4121 2.00053V2Z"
        fill="#F46A54"
      />
    </svg>
  );
}
